import { useEffect, useState } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#050505]/80 backdrop-blur-xl border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-16 py-5 flex items-center justify-between">
        <a
          href="#top"
          data-testid="brand-logo"
          className="font-display text-2xl tracking-[0.2em] text-[#F5F2EA] hover:text-[#155E63] transition-colors"
        >
          AEVUM
        </a>

        <ul className="hidden md:flex items-center gap-12 text-[11px] tracking-[0.25em] uppercase text-[#A3A3A3] font-medium">
          <li>
            <a
              href="#ethos"
              data-testid="nav-ethos"
              className="hover:text-[#F5F2EA] transition-colors"
            >
              Ethos
            </a>
          </li>
          <li>
            <a
              href="#manifesto"
              data-testid="nav-manifesto"
              className="hover:text-[#F5F2EA] transition-colors"
            >
              Manifesto
            </a>
          </li>
          <li>
            <a
              href="#newsletter"
              data-testid="nav-newsletter"
              className="hover:text-[#F5F2EA] transition-colors"
            >
              Join
            </a>
          </li>
        </ul>

        <a
          href="#newsletter"
          data-testid="nav-cta"
          className="text-[11px] tracking-[0.25em] uppercase border border-white/20 px-5 py-2.5 hover:bg-[#F5F2EA] hover:text-[#050505] transition-colors duration-300"
        >
          Enter
        </a>
      </nav>
    </header>
  );
}
